import type { FaireBrandEntity } from "../../entity_types/brand";

// Anonymized stand-in for the P2 "median advertiser" archetype (real metrics, fake identity).
export const bAdvP2Median: FaireBrandEntity = {
  token: "b_adv_p2_median",
  type: "brand",
  name: "Sage & Cedar Home",
  description: "Small-batch bath, body, and home care goods",
  location: "Toronto, ON",
  rating: 4.7,
  minimumOrderDollars: 150,
  tags: ["bath-body", "home-care", "sustainable"],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
